import { call, put } from "redux-saga/effects";
import { resolvePromiseAction, rejectPromiseAction } from "@adobe/redux-saga-promise";

import Api from "common/api";
import constants from "./constants";

export default {
  /**
   * call getLeadTarget api
   * @param {*} data
   */
  getLeadTarget: function* (data) {
    const __name = constants.GET_LEAD_TARGET;
    try {
      const res = yield call(Api.getLeadTarget, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call saveCRMSettingLeadForm api
   * @param {*} data
   */
  saveCRMSettingLeadForm: function* (data) {
    const __name = constants.SAVE_CRM_SETTING_LEAD_FORM;
    try {
      const res = yield call(Api.saveCRMSettingLeadForm, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * set gate item
   * @param {*} data
   */
  setGateItem: function* (data) {
    const __name = constants.SET_GATE_ITEM;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * call saveCRMGGLeadsSetting api
   * @param {*} data
   */
  saveCRMGGLeadsSetting: function* (data) {
    const __name = constants.SAVE_CRM_GG_LEADS_SETTING;
    try {
      const res = yield call(Api.saveCRMGGLeadsSetting, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * set crm loading
   * @param {*} data
   */
  setCRMLoading: function* (data) {
    const __name = constants.SET_CRM_LOADING;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  /**
   * set validate gate
   * @param {*} data
   */
  setValidateGate: function* (data) {
    const __name = constants.SET_VALIDATE_GATE;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
